import { CircularProgress, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { useSettingContext } from "context/SettingContext";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { getIcon } from "utils/iconsConfig";
import ClientModal from "components/ui/clientModal/clientModal";
import { useLocation, useParams } from "react-router-dom";
import apiClient from "lib/api-client";
import { formatDate, formatDesignDate } from "utils/formatDate";
import { useClientCompanyEmployees } from "./Api/myBinnysAccessApi";
import { capitalEachLetter } from "utils/capitalEachLetter";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, hasAccessPage, isAllowed } from "utils/checkUserRigths";

import { Checkbox } from "@mui/material";
import { Check } from "@mui/icons-material";
import { toast } from "react-toastify";
import UserAccessTray from "./UserAccessTray";

const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border: 1px solid #fff;
  max-height: 58.5vh;
  overflow: auto;
  position: relative;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

const StyledTable = styled(Table)(({}) => ({
  "& thead": {
    backgroundColor: "#444444",
    position: "sticky",
    top: 0,
    zIndex: 1,
    "& th": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      padding: "10px",
      borderBottom: "1px solid #fff",
    },
  },
  "& tbody": {
    "& td": {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      borderBottom: "1px solid #fff",
      padding: "10px 5px",
      border: "1px solid #fff",
    },
  },
  "& th": {
    // backgroundColor: "#444444",
    height: "50px",
    // position: "sticky",
    // top: 0,
    // zIndex: 1,
  },
}));

const StyledTableHeaderCell = styled(TableCell)`
  padding: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: #444444;
  color: white;
  text-align: center !important;
  position: sticky;
  top: 0;
  z-index: 10;
  border: none !important;

  &.narrow {
    width: 9%;
  }
  &.narrow_status {
    width: 1%;
  }

  &.default {
    width: 10%;
  }
`;

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid #fff;
  & td {
    padding: 5px;
  }
  &.clickable {
    cursor: pointer;
  }
  &.clickable:hover td {
    background-color: #1a1a1a;
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  padding: 5px;
  text-align: center;
  font-family: karla !important;

  &.narrow {
    width: 11%;
    font-size: 14.5px;
  }

  &.narrow_status {
    width: 1%;
  }

  &.appVersion {
    width: 1%;
    color: #8b8b8b;
  }

  &.default {
    width: 19.5%;
    font-size: 14.5px;
  }

  &.default-button {
    width: 8%;
    font-size: 14px;
  }
`;

const CustomUncheckedIcon = styled("span")(({ theme, disabled }) => ({
  width: 18,
  height: 18,
  borderRadius: 5, // Rounded corners
  border: "1px solid #ccc", // Border for unchecked state
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: disabled ? 0.6 : 1,
  margin: "0 !important",
}));

const CustomCheckedIcon = styled("span")(({ theme, disabled }) => ({
  width: 18,
  height: 18,
  borderRadius: 5,
  backgroundColor: "#50C878",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff !important",
  opacity: disabled ? 0.6 : 1,
  margin: "0 !important",
}));

function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

const ClientsUserDetails = () => {
  const { setCreateBtn, setCreateBtnName, addClient, setAddClient, search, setSearch, setSearchBar } = useSettingContext();
  const { setSearchPlaceHolder } = useGlobalContext();
  const [dustbinModalOpen, setDustbinModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState({});
  const permissions = usePermissions();
  // const addClientPermission = hasAccessPage(findSpecificPage("My Binny’s App", permissions), "add");
  const deleteClientPermission = hasAccessPage(findSpecificPage("My Binny’s App", permissions), "archive");
  const [modalType, setModalType] = useState("");
  const [selectedStatusAction, setSelectedStatusAction] = useState("");
  const [selectedAdminAction, setSelectedAdminAction] = useState("");
  const [accessTrayUser, setAccessTrayUser] = useState(null);
   const addClientPermission = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "add");
  const hasUserDeleteAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "delete");
  const hasUserControlAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "user_control");

  const { clientId } = useParams();
  const tableRef = useRef();
  const location = useLocation();

  useEffect(() => {
    setCreateBtn(addClientPermission);
    setSearchBar(true);
    setSearchPlaceHolder("Search By User Name , Mobile Number");
    setCreateBtnName("Add User +");
    return () => {
      setCreateBtn(false);
      setSearchBar(false);
      setCreateBtnName("");
      setSearchPlaceHolder("");
    };
  }, [addClientPermission]);

  useEffect(() => {
    return () => {
      setSearchBar(false);
      setSearch("");
      setSearchPlaceHolder("");
    };
  }, []);

  //------------------------------------------------------------  USER TABLE DATA API ------------------------------------------------------------------\\

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, refetch } = useClientCompanyEmployees(clientId, search);

  useEffect(() => {
    const handleScroll = () => {
      const el = tableRef.current;
      if (!el || isFetchingNextPage || !hasNextPage) return;

      const { scrollTop, scrollHeight, clientHeight } = el;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        fetchNextPage();
      }
    };

    const debounced = debounce(handleScroll, 300); // Utility debounce function
    const el = tableRef.current;
    if (el) el.addEventListener("scroll", debounced);

    return () => el?.removeEventListener("scroll", debounced);
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const discardChanges = () => {
    setDustbinModalOpen(false);
  };

  const handleDelete = (rowData) => {
    setSelectedClient(rowData);
    setModalType("delete");
    setDustbinModalOpen(true);
  };

  const handleStatusToggle = (user) => {
    setSelectedClient(user);
    setSelectedStatusAction(user.isStatus ? "deactivate" : "activate");
    setModalType("status");
    setDustbinModalOpen(true);
  };

  const handleAdminAccess = (user) => {
    setSelectedAdminAction(user?.isAdmin ? "remove" : "make");
    setSelectedClient(user);
    setModalType("adminaccess");
    setDustbinModalOpen(true);
  };

  //------------------------------------------------------------  DELETE ROW API ------------------------------------------------------------------\\

  const confirmDelete = async () => {
    try {
      await apiClient.patch(`/api/v9/myBinnys/visionClientCompanyEmployee?emId=${selectedClient._id}`);
      refetch();
      setDustbinModalOpen(false);
    } catch (error) {
      console.error("Error deleting user:", error);
      const message = error?.response?.data?.message || error?.message || "Something went wrong";
      toast.error(`${message}`, {
        autoClose: 2000,
        hideProgressBar: false,
      });
      setDustbinModalOpen(false);
    }
  };

  //------------------------------------------------------------  UPDATE STATUS API ------------------------------------------------------------------\\

  const confirmStatusToggle = async () => {
    try {
      setLoadingStatus((prev) => ({ ...prev, [selectedClient._id]: true }));
      await apiClient.patch(`/api/v9/myBinnys/updateStatusClientUsers?emId=${selectedClient._id}`);
      refetch();
    } catch (error) {
      console.error("Error toggling user status:", error);
      toast.error(`${error?.response?.data?.message}`, {
        autoClose: 2000,
        hideProgressBar: false,
      });
    } finally {
      setLoadingStatus((prev) => ({ ...prev, [selectedClient._id]: false }));
      setDustbinModalOpen(false);
    }
  };

  const confirmIsAdminStatusToggle = async () => {
    try {
      await apiClient.patch(`/api/v9/myBinnys/updateIsAdminStatusClientUsers?emId=${selectedClient._id}&isAdmin=${selectedClient.isAdmin ? false : true}`);
      refetch();
      // toast.success(`${data?.data?.message}`, {
      //   autoClose: 1000,
      //   hideProgressBar: false,
      // });
    } catch (error) {
      console.error("Error toggling user status:", error);
      toast.error(`${error?.response?.data?.message}`, {
        autoClose: 3000,
        hideProgressBar: false,
      });
    } finally {
      setDustbinModalOpen(false);
    }
  };

  const btnInfo =
    modalType === "delete"
      ? [
          {
            btnName: "Remove",
            bgColor: "#E77B7B",
            click: confirmDelete,
          },
          {
            btnName: "No",
            bgColor: "#50c878",
            click: discardChanges,
          },
        ]
      : modalType === "status"
        ? [
            {
              btnName: capitalEachLetter(selectedStatusAction),
              bgColor: "#E77B7B",
              click: confirmStatusToggle,
            },
            {
              btnName: "No",
              bgColor: "#50c878",
              click: discardChanges,
            },
          ]
        : [
            {
              btnName: "No",
              bgColor: "#E77B7B",
              click: discardChanges,
            },
            {
              btnName: "Yes",
              bgColor: "#50c878",
              click: confirmIsAdminStatusToggle,
            },
          ];

  const TableSkeleton = ({ columns, rows = 5 }) => (
    <>
      {Array.from(new Array(rows)).map((_, rowIndex) => (
        <StyledTableRow key={`skeleton-${rowIndex}`}>
          {Array.from(new Array(columns)).map((_, cellIndex) => (
            <StyledTableBodyCell key={`skeleton-cell-${cellIndex}`}>
              <Skeleton variant="text" sx={{ fontSize: "1rem" }} animation="wave" width={"100%"} height={"90%"} />
            </StyledTableBodyCell>
          ))}
        </StyledTableRow>
      ))}
    </>
  );

  return (
    <>
      <div style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px", backgroundColor: "#000", padding: "10px" }}>
        <StyledTableContainer ref={tableRef}>
          <StyledTable>
            <TableHead>
              <TableRow>
                <StyledTableHeaderCell className="default">User Name</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow">Mobile Number</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow">Email</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow">Created Date</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow">Created by</StyledTableHeaderCell>
                <StyledTableHeaderCell className="default">First Login</StyledTableHeaderCell>
                <StyledTableHeaderCell className="default">Recent Login</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow_status">Version</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow_status">Status</StyledTableHeaderCell>
                <StyledTableHeaderCell className="narrow">Actions</StyledTableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableSkeleton columns={9} rows={10} />
              ) : (
                data?.pages?.map((page) =>
                  page.employees.map((user) => (
                    <StyledTableRow key={user._id} className="clickable" onClick={() => setAccessTrayUser(user)}>
                      <StyledTableBodyCell className="default">{capitalEachLetter(user?.clientUserName)}</StyledTableBodyCell>
                      <StyledTableBodyCell className="narrow">{user?.clientUserMobileNumber}</StyledTableBodyCell>
                      <StyledTableBodyCell className="narrow">{user?.clientUserEmail}</StyledTableBodyCell>
                      <StyledTableBodyCell className="narrow">{formatDate(user?.accessDate)}</StyledTableBodyCell>
                      <StyledTableBodyCell className="narrow">{user?.accessBy}</StyledTableBodyCell>
                      <StyledTableBodyCell className="default">{formatDesignDate(user?.firstLoginDate) || "-"}</StyledTableBodyCell>
                      <StyledTableBodyCell className="default">{formatDesignDate(user?.recentLoginDate) || "-"}</StyledTableBodyCell>
                      <StyledTableBodyCell className="appVersion">{user?.currentAppVersion || "2.0.0"}</StyledTableBodyCell>
                      <StyledTableBodyCell className="narrow_status">
                        <span
                          style={{
                            display: "inline-block",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            border: `1px solid ${user.isStatus ? "#50C878" : "#E77B7B"}`,
                            backgroundColor: user.isStatus ? "#50C878" : "#E77B7B",
                          }}
                        ></span>
                      </StyledTableBodyCell>
                      <StyledTableBodyCell className="default-button">
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }} onClick={(e) => e.stopPropagation()}>
                          {hasUserControlAccess && <button
                            style={{
                              backgroundColor: "black",
                              border: `1px solid ${user.isStatus ? "#E77B7B" : "#50C878"}`,
                              color: user.isStatus ? "#E77B7B" : "#50C878",
                              padding: "4px 12px",
                              borderRadius: "6px",
                              fontWeight: 500,
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              cursor: "pointer",
                              width: "5vw",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            onClick={() => handleStatusToggle(user)}
                            disabled={loadingStatus[user._id]}
                          >
                            {loadingStatus[user._id] ? <CircularProgress size={16} color="inherit" /> : user.isStatus ? "Deactivate" : "Activate"}
                          </button>}
                          {hasUserControlAccess && <button
                            style={{
                              backgroundColor: "black",
                              border: `1px solid ${!user.isAdmin ? "#8B8B8B" : "#50C878"}`,
                              color: !user.isAdmin ? "#8B8B8B" : "#50C878",
                              padding: "4px 4px",
                              borderRadius: "6px",
                              fontWeight: 500,
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              cursor: "pointer",
                              width: "4.8vw",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            // onClick={() => handleStatusToggle(user)}
                            // disabled={loadingStatus[user._id]}
                          >
                            {"Admin"}

                            <Checkbox
                              sx={{ padding: "0 !important" }}
                              disableRipple
                              checked={user.isAdmin ? true : false}
                              icon={<CustomUncheckedIcon />}
                              onChange={() => handleAdminAccess(user)}
                              checkedIcon={
                                <CustomCheckedIcon>
                                  <Check style={{ fontSize: 18 }} />
                                </CustomCheckedIcon>
                              }
                            />
                          </button>}
                          {hasUserDeleteAccess && (
                            <span style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => handleDelete(user)}>
                              {getIcon("DustbinIcon", "white")}
                            </span>
                          )}
                        </div>
                      </StyledTableBodyCell>
                    </StyledTableRow>
                  ))
                )
              )}
              {isFetchingNextPage && <TableSkeleton columns={9} rows={5} />}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </div>
      <RemoveModal
        open={dustbinModalOpen}
        setOpen={setDustbinModalOpen}
        btnInfo={btnInfo}
        heading={
          modalType === "delete"
            ? `Are you sure you want to remove ${capitalEachLetter(selectedClient?.clientUserName)}?`
            : modalType === "status"
              ? `Are you sure you want to ${selectedStatusAction} ${capitalEachLetter(selectedClient?.clientUserName)}?`
              : `Are you sure you want to ${selectedAdminAction} *${capitalEachLetter(selectedClient?.clientUserName)}* ${selectedAdminAction === "remove" ? "as" : ""} an admin?`
        }
        oneLiner={true}
        isBold={true}
      />
      <UserAccessTray open={!!accessTrayUser} onClose={() => setAccessTrayUser(null)} user={accessTrayUser} canEdit={hasUserControlAccess} />
      <ClientModal open={addClient} onClose={() => setAddClient(false)} type="addUser" onSuccess={refetch} />
    </>
  );
};

export default ClientsUserDetails;
